import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { getMe } from './services/api';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Publish from './pages/Publish';
import MyPosts from './pages/MyPosts';
import Admin from './pages/Admin';
import About from './pages/About';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getMe()
        .then(res => setUser(res.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setMobileMenuOpen(false);
  };

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">加载中...</div>;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <nav className="bg-blue-600 text-white shadow-lg sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center">
                <Link to="/" className="text-xl font-bold hover:text-blue-200 transition-colors">
                  铁路对调网
                </Link>
              </div>
              
              {/* 桌面端菜单 */}
              <div className="hidden md:flex items-center space-x-1">
                <Link to="/" className="hover:bg-blue-700 px-4 py-2 rounded-lg transition-colors">首页</Link>
                <Link to="/about" className="hover:bg-blue-700 px-4 py-2 rounded-lg transition-colors">关于我们</Link>
                {user ? (
                  <>
                    <Link to="/publish" className="hover:bg-blue-700 px-4 py-2 rounded-lg transition-colors">发布信息</Link>
                    <Link to="/myposts" className="hover:bg-blue-700 px-4 py-2 rounded-lg transition-colors">我的发布</Link>
                    {user.username === 'admin' && (
                      <Link to="/admin" className="hover:bg-blue-700 px-4 py-2 rounded-lg transition-colors">后台管理</Link>
                    )}
                    <span className="bg-blue-700 px-3 py-1 rounded-full text-sm ml-2">{user.username}</span>
                    <button 
                      onClick={handleLogout} 
                      className="hover:bg-blue-700 px-4 py-2 rounded-lg transition-colors"
                    >
                      退出
                    </button>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="hover:bg-blue-700 px-4 py-2 rounded-lg transition-colors">登录</Link>
                    <Link to="/register" className="bg-white text-blue-600 hover:bg-blue-50 px-4 py-2 rounded-lg font-semibold transition-colors ml-2">注册</Link>
                  </>
                )}
              </div>
              
              {/* 移动端汉堡包按钮 */}
              <div className="md:hidden">
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="inline-flex items-center justify-center p-2 rounded-lg hover:bg-blue-700 focus:outline-none transition-colors"
                  aria-label="菜单"
                >
                  {mobileMenuOpen ? (
                    <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
          
          {/* 移动端菜单 */}
          {mobileMenuOpen && (
            <div className="md:hidden bg-blue-700 border-t border-blue-600">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 space-y-2">
                <Link 
                  to="/" 
                  onClick={() => setMobileMenuOpen(false)}
                  className="block px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                >
                  首页
                </Link>
                <Link 
                  to="/about" 
                  onClick={() => setMobileMenuOpen(false)}
                  className="block px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                >
                  关于我们
                </Link>
                {user ? (
                  <>
                    <div className="pt-2 border-t border-blue-500 mt-2">
                      <div className="px-4 py-2 text-blue-200 text-sm">
                        {user.username}
                      </div>
                    </div>
                    <Link 
                      to="/publish" 
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                    >
                      发布信息
                    </Link>
                    <Link 
                      to="/myposts" 
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                    >
                      我的发布
                    </Link>
                    {user.username === 'admin' && (
                      <Link 
                        to="/admin" 
                        onClick={() => setMobileMenuOpen(false)}
                        className="block px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                      >
                        后台管理
                      </Link>
                    )}
                    <button 
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium bg-red-500 hover:bg-red-600 mt-2"
                    >
                      退出登录
                    </button>
                  </>
                ) : (
                  <>
                    <div className="pt-2 border-t border-blue-500 mt-2" />
                    <Link 
                      to="/login" 
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
                    >
                      登录
                    </Link>
                    <Link 
                      to="/register" 
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-3 rounded-lg bg-white text-blue-600 hover:bg-blue-50 transition-colors font-medium mt-2"
                    >
                      注册账号
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>

        <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={user ? <Navigate to="/" /> : <Login setUser={setUser} />} />
            <Route path="/register" element={user ? <Navigate to="/" /> : <Register setUser={setUser} />} />
            <Route path="/publish" element={user ? <Publish /> : <Navigate to="/login" />} />
            <Route path="/myposts" element={user ? <MyPosts /> : <Navigate to="/login" />} />
            <Route path="/admin" element={user && user.username === 'admin' ? <Admin /> : <Navigate to="/" />} />
          </Routes>
        </main>

        <footer className="bg-gray-800 text-white mt-12">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <p>弘建网旗下的全国铁路职工对调平台，为全国铁路职工服务！</p>
              <p className="text-gray-400 text-sm mt-2">© {new Date().getFullYear()} 铁路对调网</p>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
